import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Stack } from "@mui/material";

const CustomGrid = (props) => {
    const { border, borderleft, borderRight, disablePadding, text, records, rowHeight } = props;

    useEffect(() => {
        // console.log("CustomGrid :: ",records);
    }, []);

    return (
        <Grid
            sx={{
                border: border ? "1px solid" : "none",
                borderColor: "#E8E8E8",
                borderRadius: 2,
                py: 0,
            }}
            container
            justifyContent="start">
            {Object.keys(records).map((innerAttr, index) => {
                return (
                    <Grid item xs={12} sm={12} md={records[innerAttr].size ? records[innerAttr].size : 2}>
                        <Box
                            sx={{
                                height: disablePadding ? 20 : rowHeight ? rowHeight : 144,
                                minHeight: disablePadding ? 20 : 144,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRight: borderRight
                                    ? Object.keys(records)?.length - 1 > index
                                        ? "1px solid"
                                        : "none"
                                    : "none",
                                borderColor: "#E8E8E8",
                            }}>
                            <Typography
                                sx={{ width: "100%" }}
                                variant="caption"
                                color={text === "primary" ? "text.primary" : "text.secondary"}>
                                <strong>{records[innerAttr].body}</strong>
                            </Typography>
                        </Box>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export { CustomGrid };
